module.exports = __webpack_public_path__ + "assets/img/70x_519_3.d0d3eb80.jpg";